<style lang="less">
  @import "./PhotoList.less";
</style>
<style scoped>
  @import '../../../assets/css/eprendersdk.min.css';
</style>
<template>
  <div class="photo-list">

    <div class="photo-list-top">
      <h3>{{photoAlbumTitle}}</h3>
      <!--<span>编辑</span>-->
    </div>

    <!--双层循环-->
    <!--<div v-if="photoList && photoList.length>0">-->
      <!--<div class="photo-list-con clear" v-for="(groupItem, index) in photoList" :key="index">-->
        <!--<h4>{{groupItem.createTime}}</h4>-->
        <!--<p class="gray-color">{{groupItem.areas}}</p>-->
        <!--<div v-for="item in groupItem.rows" :key="item._id">-->
          <!--<img v-if="item.url_thumb" :src="item.url_thumb" alt="" @click="previewImageFn(index)">-->
          <!--<img v-if="!item.url_thumb" src="../../../assets/images/img_default01.png" alt="" @click="previewImageFn(index)">-->
          <!--&lt;!&ndash;<p>{{item.createTime}}</p>&ndash;&gt;-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->

    <!--没有数据-->
    <div class="no-data" v-if="!(photoList && photoList.length>0)">
      <img alt="" src="../../../assets/images/ic_no_data.png">
      <p>{{isQuery?'未查询到数据':'还没有' + photoAlbumTitle + '哦~'}}</p>
    </div>

    <!--播放视频-->
    <van-popup v-model="showVideo" :overlay-style="{'background-color': '#ffffff'}" @click-overlay="clickOverlay">
      <!--<video :src="videoUrl" controls="controls" :poster="videoThumb"></video>-->
      <video controls="controls" :poster="videoThumb" playsinline x5-playsinline="true" id="playVideos">
        <source :src="videoUrl" type="video/mp4"/>
      </video>
      <p class="gray-color">点击上下空白处返回</p>
    </van-popup>

    <!--加载-->
    <van-list
      v-model="loading"
      :finished="finished"
      :immediate-check="false"
      :finished-text="photoList && photoList.length>0 ? '没有更多数据了' : ''"
      :offset="30"
      @load="onLoad"
    >
      <!--双层循环(按日期再按地理位置分组)-->
      <div v-if="photoList && photoList.length>0">
        <div class="photo-list-con clear" v-for="(groupItem, groupIndex) in photoList" :key="groupIndex">
          <h4>{{groupItem.finishTimeShow}}</h4>
          <!-- <p class="gray-color address-text">{{groupItem.location || '地址解析中...'}}</p> -->
          <p class="gray-color address-text"></p>
          <div v-for="(item, index) in  groupItem.children" :key="item._id">
            <template v-if='item.camera===4'>
              <div v-if="item.mtype===1" class="d3Img" @click.stop='fullScreenHandle(item,1)'>
                <img src="../../../assets/images/xc_3d_pic.png"  alt="">
              </div>
              <div v-if="item.mtype===2" @click='fullScreenHandle(item,2)' >
                <img src="../../../assets/images/xc_3d_sp.png"  alt="">
                <van-icon name="play" class="play" color="#ffffff" size="30" v-if="item.mtype===2"/>
              </div>
            </template>
            <template v-else>
              <img v-if="item.url_thumb" :src="item.url_thumb" alt="" @click="item.mtype===2?playVideoFn(item.url, item.url_thumb, item._id):previewImageFn(groupIndex, index)">
              <img v-else src="../../../assets/images/img_default01.png" alt="" @click="item.mtype===2?playVideoFn(item.url, item.url_thumb, item._id):previewImageFn(groupIndex, index)">
              <van-icon name="play" class="play" color="#ffffff" size="30" v-if="item.mtype===2" @click="playVideoFn(item.url, item.url_thumb, item._id)"/>
            </template>
          </div>
        </div>
      </div>
    </van-list>
    <div id='demoVideo' v-show='isshow'></div>
    <span id="close" v-show='isshow'><img @click='closeHandle' src="../../../assets/img/ep_mode_close.png" alt=""></span>
    <van-popup v-model="show" @close='closeHandle'>
      <div id='demo3d'>
        <img :src="url_thumb" alt="" @load='change3DImg("demo4d")' style="visibility: hidden;">
        <div id="demo4d"></div>
      </div>
    </van-popup>
    <span id="close" v-show='show'><img @click='show=false' src="../../../assets/img/ep_mode_close.png" alt=""></span>
  </div>
</template>

<script>
import PhotoList from './PhotoList.js'
export default {
  ...PhotoList
}
</script>
